export default __webpack_public_path__ + "img/mobile-back.ffb056da.svg";